// a jegylista URL-szűrőinek kulcs-készlete — külön modulban, hogy a route-fájl csak komponenst exportáljon,
// és a teszt a route-séma ellen ellenőrizhesse

/** A select-szűrők „mind" értéke. */
export const TICKET_LIST_ALL = '__all__';

/** A lista URL-szűrőinek alapértékei — egyben a kulcs-készlet (`useListFilters`); a route-sémának mindet ismernie kell. */
export const TICKET_LIST_FILTER_DEFAULTS = {
  q: '',
  // Deep-link a létrehozáshoz (a kezdőlap gyors-műveletéből); üres = nincs az URL-ben.
  new: '',
  status: TICKET_LIST_ALL,
  type: TICKET_LIST_ALL,
  group: 'in_progress',
  mine: '',
  // SUPPORT-CSAPAT + LÉTREHOZÁS-DÁTUM tartomány (a szűrő-popover mezői; üres = nincs szűrés).
  team: TICKET_LIST_ALL,
  from: '',
  to: '',
  // LEZÁRÁS-DÁTUM tartomány — csak a „Lezárt" fülön látszik és hat.
  closedFrom: '',
  closedTo: '',
  // UTOLSÓ AKTIVITÁS szerint, csökkenően: az új hozzászólású jegy felülre kerül (2. tesztkör, user-döntés).
  sort: 'lastActivityAt',
  order: 'desc',
};
